import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data); 
export const getLoginUserReport = (data) => Ajax.post('hr/getLoginUserReport',data);